import type { ApiHttpClient } from "../interfaces/api-http-client";
import { buildSuggestionRequest } from "./suggestion";
import type { SuggestionDraft, SuggestionResult } from "./types";

const TOO_MANY_REQUESTS = 429;

/** The hourly limit's next allowed time from a 429 body, or null when the 429 came from another limiter. */
function nextAllowedAtOf(body: unknown): string | null {
  if (!body || typeof body !== "object") return null;
  const value = (body as { nextAllowedAt?: unknown }).nextAllowedAt;
  return typeof value === "string" && !Number.isNaN(Date.parse(value)) ? value : null;
}

export function createFeedbackApi(http: ApiHttpClient) {
  return {
    /** POST /feedback with a suggestion; a 429 with `nextAllowedAt` is the hourly limit, any other failure keeps the text for a retry. */
    async sendSuggestion(draft: SuggestionDraft): Promise<SuggestionResult> {
      const response = await http.post<{ id?: string }>("/feedback", buildSuggestionRequest(draft));
      if (response.success) return { status: "sent" };
      const nextAllowedAt = response.status === TOO_MANY_REQUESTS ? nextAllowedAtOf(response.errorBody) : null;
      if (nextAllowedAt) return { status: "rate_limited", nextAllowedAt };
      return { status: "failed", error: response.error ?? "Request failed" };
    },
  };
}
